import PropTypes from 'prop-types';

const CalendarIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6.5" y="12" width="68.0001" height="60" fill="#F4EFED" />
    <rect x="6.5" y="12" width="68.0001" height="18" fill="#FFCCEF" />
    <rect x="18.5" y="6" width="8.00001" height="12" fill="#0A0777" />
    <rect x="54.5" y="6" width="8.00001" height="12" fill="#0A0777" />
  </svg>
);

CalendarIcon.propTypes = {
  className: PropTypes.string
};

export default CalendarIcon;
